export enum UserStatus {
    active = 'ACTIVE',
    inactive = 'INACTIVE'
}

export enum UserStatusLabels {
    active = 'Active',
    inactive = 'Inactive'
}
  